import { useState } from "react";

const SaleModal = (props) => {
    const [copied, setCopied] = useState(false);
    const walletAddress = "rEXcAnD9z9BzQYNK6ZRtK5jhwTHP6YpMjJ";

    const handleCopy = () => {
        navigator.clipboard.writeText(walletAddress).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
      };

    return (
        <div className="sale-modal">
            <div className="sale-modal-content">
                <div className="sale-modal-header">
                    <h1>Join $NMA Presale <span className="sale-modal-close-icon" onClick={() => props.setShowSaleModal(prev => !prev)}>X</span></h1>
                    <img src={`https://api.qrserver.com/v1/create-qr-code/?size=256x256&data=${walletAddress}`} alt="sale address" />
                    <br />
                    <input type="text" className="sale-address-input" value={walletAddress} readOnly />
                    <button onClick={handleCopy} className="ico_btn_outline mt-2" id="copy-addr"><i class="icon-copy"></i>{copied ? "Copied" : "Copy Address"}</button>
                    <div className="sale-modal-how-to-buy-box">
                        <p className="sale-modal-how-to-buy-title">How To Buy</p>
                        <div className="sale-modal-how-to-buy">
                            <p>Buy XRP From a Reputable Exchange like Binance, Coinbase etc</p>
                            <p>Send To Your XRP-Compatible Wallet (Xaman)</p>
                            <p>Copy and Send XRP to the Presale Address above</p>
                            <p>Set Up Trustline For NMA <a href="https://xrpl.services/?issuer=rf34Lq4Hfcfe1PonfsPBr2pSo62pFvCi6R&currency=NMA&limit=200000000" target="_blank" rel="noreferrer">Here</a></p>
                            <p>NMA Tokens Will Be Airdropped Immediately Presale ends</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SaleModal;